import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class ServiceListContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
            category:this.props.category
        }
        

    }

    componentDidMount()
    {  
         
         this.setState({loading:0});      
        
    }


    render()
    { 
       
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (
       <div className="body-block">
  <div className="page-block">
    <div className="barrier">
      <div
        className="pages-headline aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div className="pages-breadcumbs">
          <div className="crumbs">
            <div className="crumb">
              <a href="/" className="nuxt-link-active">HOME</a>
            </div>
            <div className="crumb">
              <a href="/services" className="nuxt-link-active">
                <span className="crumb-slash">/</span>services
              </a>
            </div>
            <div className="crumb"></div>
          </div>
        </div>

        <div className="pages-heading">
          <b>{this.state.category.title}</b>
        </div>
      </div>
  
       <section className="service-cards">
         {this.state.category.services.map((item, index) => (
          <Link
          to={base_url+`services/${item.slug}`} 
          className="service-card aos-init aos-animate"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-delay="100"
        >
          <div
            className="service-image aos-init aos-animate"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            <img
              loading="lazy"
              src={item.image}
              alt={item.title}
            />
          </div>

          <div className="service-wrapper">
            <h1
              className="service-content-headline aos-init aos-animate"
              data-aos="fade-in"
              data-aos-duration="1000"
            >
              {item.title}
            </h1>

            <div
              className="service-content-text aos-init aos-animate"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
             {item.short_info}
            </div>

            <div
              className="service-content-link aos-init aos-animate"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              READ MORE
            </div>
          </div>
        </Link>
         ))}

       </section>
 
         
    

       </div>
       </div>
       </div>

    );
}

}

export default ServiceListContent;